import { IGallery } from "../store/services/invitations/dto/invitations.dto";
import { cloneDeep } from "lodash";

export const prepareImageList = (
	files: { file_path: string; optimized_path: string | null }[],
	fieldValueState: IGallery[]
) => {
	let preparedList = cloneDeep(fieldValueState);
	files.forEach(file => {
		const _order = file.file_path.split("-").pop();
		const image_index = preparedList.findIndex(item => item.order === +(_order || 0));
		const isVideo = file.file_path.includes("mediaTypeVideo");
		if (image_index > -1) {
			if (isVideo) {
				preparedList[image_index].video_url = file.optimized_path || file.file_path;
			} else {
				preparedList[image_index].image_url = file.optimized_path || file.file_path;
			}
		}
	});
	return preparedList;
};
